"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.apiPost = exports.api = void 0;
/* eslint-disable @typescript-eslint/no-explicit-any */
var app_1 = require("app");
var axios_1 = require("axios");
var api = function (apiUrl, params, headers, cancelToken, timeout) {
    var requestParams = {
        method: 'get',
        responseType: 'json',
        url: apiUrl + app_1.UrlService.GetStringFromUrlObj(params),
    };
    if (headers) {
        requestParams.headers = headers;
    }
    if (cancelToken) {
        requestParams.cancelToken = cancelToken;
    }
    if (timeout) {
        requestParams.timeout = timeout;
    }
    return axios_1.default(requestParams);
};
exports.api = api;
var apiPost = function (apiUrl, params, headers, cancelToken, timeout) {
    var requestParams = {
        data: params,
        method: 'post',
        url: apiUrl,
    };
    if (headers) {
        requestParams.headers = headers;
    }
    if (cancelToken) {
        requestParams.cancelToken = cancelToken;
    }
    if (timeout) {
        requestParams.timeout = timeout;
    }
    return axios_1.default(requestParams);
};
exports.apiPost = apiPost;
